<template>
    <div>
        <b-row>
            <b-col>
                <artist :artist="release.artist" @update="doUpdate('artist', $event)" class="mb-3"></artist>
            </b-col>
            <b-col>
                <titles ref="titles" :titles="release.titles" @update="doUpdate('titles', $event)"></titles>
            </b-col>

            <b-col>
                <item-label :label="release.label" @update="doUpdate('label', $event)" class="mb-3"></item-label>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <genre :genres="release.genres" @update="doUpdate('genres', $event)"></genre>
            </b-col>

            <b-col>
                <media-list :media="release.media" @dropNote="handleDrop($event)" @update="doUpdate('media', $event)"></media-list>
            </b-col>

            <b-col>
                <pressing :pressing="release.pressing" @dropNote="handleDrop($event)" @update="doUpdate('pressing', $event)" class="mb-3"></pressing>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <notes :notes="itemNotes" :noteDropped="noteDropped" @update="doNotesUpdate($event)"></notes>
            </b-col>

            <b-col>
                <sales :item="item" />
            </b-col>

            <b-col>
                <integration :integrations="release.integrations"  @update="doUpdate('integrations', $event)"></integration>
            </b-col>
        </b-row>

        <!--<b-row>-->
            <!--<b-col xl="3" lg="6">-->
                <!--<artist :artist="release.artist" @update="doUpdate('artist', $event)" class="mb-3"></artist>-->
                <!--<titles :titles="release.titles" @update="doUpdate('titles', $event)"></titles>-->
            <!--</b-col>-->

            <!--<b-col xl="4" lg="6">-->
                <!--<item-label :label="release.label" @update="doUpdate('label', $event)" class="mb-3"></item-label>-->
                <!--<genre :genres="release.genres" @update="doUpdate('genres', $event)"></genre>-->
            <!--</b-col>-->

            <!--<b-col xl="5">-->
                <!--<media-list :media="release.media" @dropNote="handleDrop($event)" @update="doUpdate('media', $event)"></media-list>-->

                <!--<pressing :pressing="release.pressing" @dropNote="handleDrop($event)" @update="doUpdate('pressing', $event)" class="mb-3"></pressing>-->

                <!--<integration :integrations="release.integrations"  @update="doUpdate('integrations', $event)"></integration>-->
            <!--</b-col>-->
        <!--</b-row>-->
    </div>
</template>

<script>
    import Artist from "./Artist";
    import Titles from "./Titles";
    import ItemLabel from "./ItemLabel";
    import Genre from "./Genre";
    import MediaList from "./MediaList";
    import Pressing from "./Pressing";
    import Integration from "./Integration";
    import Notes from "./Notes";
    import Sales from "./Sales";

    export default {
        name: "ItemRelease",
        props: [ 'item', 'release', 'itemNotes', 'noteDropped' ],
        components: { Artist, Titles, ItemLabel, Genre, MediaList, Pressing, Integration, Notes, Sales },
        data() {
            return {
                // noteDropped: '',
            }
        },
        methods: {
            doUpdate(key, obj) {
                this.$emit('updateRelease', { key: key, obj: obj });
            },
            handleDrop(note) {
                this.$emit('dropNote', note);
            },
            doNotesUpdate(data) {
                this.$emit('updateNotes', data);
            },
        },
    }
</script>

<style>

</style>